<template>
  <NomadDefault
    v-if="
      !isIndex &&
      library &&
      libraryViewRouter.view.value.__name !== 'ViewLibraryDefaultLb' &&
      libraryViewRouter.view.value.__name !== 'ViewLibraryDefaultShelf'
    "
  />
  <NomadRoot v-else-if="isIndex" />
  <NomadSelectedLb v-else />
</template>
<script lang="ts" setup>
const route = useRoute();

const { libraryManager, libraryViewRouter } = inject(
  INJECT_LIBRARY_PAGE_OR_FORM
);

const { t } = useI18n();

const { library, libraryBook, links } = libraryManager;

if (library.value) useAppEventLibraryBox(library.value);

const isIndex = computed(() => route.path === '/nomad');

if (isIndex.value) {
  useAppEventView(EventView.NomadPlus, library.value.id);
}

useWebsiteHead({
  title: isIndex.value
    ? `Nomad+ - ${t('title.nomadplus')}`
    : `Nomad+ - ${library?.value?.title || libraryBook?.value?.metaTitle}`,
});

const { redirect } = useRedirect();

if (
  libraryViewRouter.view.value.__name === 'ViewLibraryDefaultLb' ||
  libraryViewRouter.view.value.__name === 'ViewLibraryShelfSingle'
) {
  if (
    library.value &&
    library.value.children &&
    library.value.children.length
  ) {
    const child = library.value.children[0];

    if (
      child.children &&
      child.children.length &&
      child.children.length === 1
    ) {
      const newPath = route.path.replace(library.value.slug, child.slug);
      await redirect(newPath);
    }
  }
}
</script>
<style lang="scss" scoped>
.banner {
  display: flex;
}

.subsection {
  .banner {
    @include above('l') {
      display: none;
    }
  }
}
</style>
